<template>
  <div class="Monitor">
    <!-- 视频监控 -->
    <div class="m-video">
      <div class="m-header">{{ monitor.name }}</div>
      <div class="m-body">
        <div id="wrapper"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import ChimeePlayer from 'chimee-player';
// import 'chimee-player/lib/chimee-player.browser.css';
export default {
  name: 'Monitor',
  props: ['monitor'],
  data() {
    return {
      myplayer: null,
    };
  },
  components: {},
  mounted() {
    this.makeWrapper();
    this.playMonitor(this.monitor.outsrc);
  },
  methods: {
    playMonitor(src) {
      if (src) {
        this.myplayer.src = src
        this.myplayer.load(src);
        this.myplayer.play();
      }
    },
    // makeWrapper() {
    //   this.myplayer = new ChimeePlayer({
    //     wrapper: '#wrapper', // video dom容器
    //     src: '',
    //     box: 'hls',
    //     isLive: true,
    //     autoplay: false,
    //     controls: true,
    //     muted: true,
    //   });
    //    console.log('播放器',this.myplayer);
    // },
  },
};
</script>

<style lang='scss' scoped>

.Monitor {
  width: 100%;
  height: 100%;
  border: 1px solid #045c89;
  .m-video {
    width: 100%;
    height: 100%;
    .m-header {
      width: 100%;
      height: 30px;
      padding-left: 20px;
      font-size: 14px;
      line-height: 30px;
      color: #fff;
      background: linear-gradient(to right, #0a576c, #0c2a46);
    }
    .m-body {
      height: 230px;
      padding: 20px;
      background-color: rgba(1, 11, 47, 0.7);
    }
  }
}
#wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#wrapper container {
  overflow: hidden;
  // width: 100vw;
  // height: 100vh;
  // max-height: 180px!important;
  // height: 180px!important;
}
video{
  // height: 180px!important;
}
</style>